import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  state: {
    organizations: [],
    organizationsLoading: false
  },
  mutations: {
    setOrganizations(state, organizations) {
      state.organizations = organizations;
    },
    setOrganizationsLoading(state, loading) {
      state.organizationsLoading = loading;
    }
  },
  actions: {
    async loadOrganizations({ commit }) {
      commit("setOrganizationsLoading", true);
      let organizations = await api.get("organizations");
      commit("setOrganizations", organizations.data);
      commit("setOrganizationsLoading", false);
    },
    async newOrganization({ commit, dispatch }, payload) {
      await api.post("organizations", payload);
      dispatch("loadOrganizations");
    },
    async saveOrganization({ commit, dispatch }, payload) {
      await api.put("organizations", payload);
      dispatch("loadOrganizations");
    },
    async grantAccessOrg({ commit, dispatch }, payload) {
      let response = [];
      if (payload.type == "admin") {
        await api
          .post("user/grantOrgAdmin", payload)
          .then(result => {
            response = result;
          })
          .catch(error => {
            response = error;
          });
      } else {
        await api
          .post("user/grantOrgUser", payload)
          .then(result => {
            response = result;
          })
          .catch(error => {
            response = error;
          });
      }
      return response;
    }
  },
  getters: {
    organizationsLoading(state) {
      return state.organizationsLoading;
    },
    organizations(state) {
      return state.organizations;
    }
  }
};
